import { REPORTS, REPORTS_DOWNLOAD, REPORTS_LOADING } from '@store/types'
import axios from 'axios'
import shortly from 'vuex-shortly'

const state = {
  reports: [],
  loading: []
}

const getters = {
  [REPORTS]: (state) => {
    const reports = state.reports.map(
      (report) => ({
        ...report,
        isLoading: state.loading.includes(report.file)
      })
    )
    return reports
  }
}

const mutations = {
  [REPORTS]: (state, payload) => {
    state.reports = payload
  },
  [REPORTS_LOADING]: (state, payload) => {
    state.loading = payload.action === 'add'
      ? [...state.loading, payload.report]
      : state.loading.filter(report => report !== payload.report)
  }
}

const actions = {
  [REPORTS]: async ({ commit }) => {
    const response = await axios.get('report/list')
    commit(REPORTS, response.data.data)
    return response
  },
  [REPORTS_DOWNLOAD]: async ({ commit }, payload) => {
    const url = 'report/' + payload.file + `?start_date=${payload.start_date}&end_date=${payload.end_date}`
    try {
      commit(REPORTS_LOADING, { report: payload.file, action: 'add' })
      const response = await axios.get(url)

      commit(REPORTS_LOADING, { report: payload.file, action: 'remove' })
      return response
    } catch (error) {
      commit(REPORTS_LOADING, { report: payload.file, action: 'remove' })
      throw error
    }
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/reports.js